import { isValidMeetingType } from './MeetingType';
import { isValidServiceGuidelines } from './Service';
export const isValidEnrichedMeetingType = properties => {
  const {
    guidelines,
    ...rest
  } = properties;
  const ans = isValidMeetingType(rest) && (guidelines ? isValidServiceGuidelines(guidelines) : true);
  return ans;
};
//# sourceMappingURL=EnrichedMeetingType.js.map